/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Информация об отправителе/получателе
 */
export type TrackingOrderPartner = {
  /**
   * Тип отправителя
   */
  type: TrackingOrderPartner.type
  /**
   * Наименование организации (для type=Legal обязательно, для type=Individual необязательно)
   */
  name?: string
}
export namespace TrackingOrderPartner {
  /**
   * Тип отправителя
   */
  export enum type {
    LEGAL = 'legal',
    INDIVIDUAL = 'individual'
  }
}
